//

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import CtaComponent from '~/components/cmscontent/cta/index.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { CtaComponent },
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  mounted() {
    console.log(this.html)
  },
  render(h, context) {
    console.log('context', context)
    if (this.html) {
      return h({
        // 注册html中用到的组件
        components: {
          CtaComponent,
        },
        template: `<div>${this.html}</div>`,
      })
    } else {
      return h({
        template: `<div>没有html</div>`,
      })
    }
  },

  // 如果页面有keep-alive缓存功能，这个函数会触发
}
